;(function () {
  const MODELS = Object.freeze({
    r1t: "R1T",
    r1s: "R1S",
    r2: "R2",
    edv: "EDV",
    rcv: "RCV",
  })
  const MIN_YEAR = 2021
  const MAX_YEAR = 2030
  const STORAGE_KEY = "fit_vehicle_selection"

  const validateModel = (raw) => {
    if (typeof raw !== "string") return null
    return MODELS[raw.toLowerCase()] || null
  }

  const validateYear = (raw) => {
    const num = parseInt(raw, 10)
    if (isNaN(num) || num < MIN_YEAR || num > MAX_YEAR) return null
    return String(num)
  }

  const loadSelection = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return null
      const data = JSON.parse(raw)
      if (!data || typeof data !== "object") return null

      const model = validateModel(data.model)
      const year = validateYear(data.year)
      if (!model && !year) return null

      return { model, year }
    } catch {
      return null
    }
  }

  const VEHICLE_MODEL_PARAM = "filter.v.m.custom.vehicle_model"
  const VEHICLE_YEAR_PARAM = "filter.v.m.custom.vehicle_year"

  const isVehicleFilterParam = (key) =>
    key === VEHICLE_MODEL_PARAM || key === VEHICLE_YEAR_PARAM

  const navigateToVehicleUrl = (model, year) => {
    const collectionBase = document.querySelector(
      "[data-vehicle-collection-url]"
    )
    if (!collectionBase) return
    if (!model && !year) return

    const baseUrl = collectionBase.getAttribute("data-vehicle-collection-url")
    const params = new URLSearchParams(window.location.search)
    const preserved = new URLSearchParams()

    for (const [key, value] of params) {
      if (isVehicleFilterParam(key)) continue
      preserved.append(key, value)
    }

    if (model) preserved.append(VEHICLE_MODEL_PARAM, model)
    if (year) preserved.append(VEHICLE_YEAR_PARAM, year)

    window.location.href = baseUrl + "?" + preserved.toString()
  }

  const handleVehicleChanged = (event) => {
    const detail = event?.detail
    if (!detail || typeof detail !== "object") return

    const model = validateModel(detail.model)
    const year = validateYear(detail.year)

    if (!model && !year) {
      clearVehicleFilter()
      return
    }

    navigateToVehicleUrl(model, year)
  }

  const updateHeaderTriggerLabel = () => {
    const selection = loadSelection()
    const triggers = document.querySelectorAll(
      ".header-fit-vehicle__trigger-label"
    )
    if (!selection || triggers.length === 0) return

    const parts = []
    if (selection.model) parts.push(selection.model)
    if (selection.year) parts.push(selection.year)
    if (parts.length === 0) return

    const label = parts.join(" ")
    for (const trigger of triggers) {
      trigger.textContent = label
    }
  }

  const clearVehicleFilter = () => {
    const collectionBase = document.querySelector(
      "[data-vehicle-collection-url]"
    )
    if (!collectionBase) return

    const baseUrl = collectionBase.getAttribute("data-vehicle-collection-url")
    const params = new URLSearchParams(window.location.search)
    const preserved = new URLSearchParams()

    for (const [key, value] of params) {
      if (isVehicleFilterParam(key)) continue
      preserved.append(key, value)
    }

    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      /* ignore */
    }

    const qs = preserved.toString()
    window.location.href = baseUrl + (qs ? "?" + qs : "")
  }

  const bindOpenModalButton = () => {
    const btn = document.querySelector("[data-vehicle-filter-open-modal]")
    if (!btn) return

    btn.addEventListener("click", () => {
      const modal = document.querySelector("[id^='FitVehicleModal-']")
      if (modal && typeof modal.show === "function") {
        modal.show(btn)
      }
    })
  }

  const bindClearButton = () => {
    const btn = document.querySelector("[data-vehicle-filter-clear]")
    if (!btn) return

    btn.addEventListener("click", clearVehicleFilter)
  }

  const populateFilterBarLabel = () => {
    const root = document.documentElement
    const model = root.dataset.vehicleModel
    const year = root.dataset.vehicleYear
    if (!model && !year) return

    const bar = document.querySelector("[data-vehicle-filter-bar]")
    if (!bar) return

    const label = bar.querySelector("[data-vehicle-filter-label]")
    if (!label) return

    let text
    if (model && year) {
      text = bar.dataset.labelBoth
        .replace("__MODEL__", model)
        .replace("__YEAR__", year)
    } else if (model) {
      text = bar.dataset.labelModel.replace("__MODEL__", model)
    } else {
      text = bar.dataset.labelYear.replace("__YEAR__", year)
    }

    label.textContent = text
  }

  const syncBarWithUrl = () => {
    const params = new URLSearchParams(window.location.search)
    const model = validateModel(params.get(VEHICLE_MODEL_PARAM))
    const year = validateYear(params.get(VEHICLE_YEAR_PARAM))
    const root = document.documentElement

    if (model || year) {
      root.classList.add("vehicle-filter-active")
      root.dataset.vehicleModel = model || ""
      root.dataset.vehicleYear = year || ""

      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ model: model ? model.toLowerCase() : null, year })
        )
      } catch {
        /* ignore */
      }
    } else {
      root.classList.remove("vehicle-filter-active")
      root.dataset.vehicleModel = ""
      root.dataset.vehicleYear = ""

      try {
        localStorage.removeItem(STORAGE_KEY)
      } catch {
        /* ignore */
      }
    }

    populateFilterBarLabel()
    updateHeaderTriggerLabel()
  }

  const init = () => {
    window.addEventListener("fit-vehicle:changed", handleVehicleChanged)
    window.addEventListener("facets:urlupdate", syncBarWithUrl)
    window.addEventListener("popstate", syncBarWithUrl)
    updateHeaderTriggerLabel()
    populateFilterBarLabel()
    bindOpenModalButton()
    bindClearButton()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()
